import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import cx from 'classnames';

interface ResultsStyleProps {
  pollChoices: any;
  pollResponse: any;
  triviaAnswerId: string;
  metrics: any;
  isTrivia: boolean;
  hasLiveMetrics: boolean;
}

interface PollChoice {
  id: string;
  label: string;
}

interface Metric {
  label: string;
  percentage: string;
}

const ResultsStyleUnstyled = ({
  pollChoices,
  pollResponse,
  triviaAnswerId,
  metrics,
  isTrivia,
  hasLiveMetrics,
}: ResultsStyleProps) => {
  return (
    <ul className="ml-4 mt-4 list-inside list-none space-y-2">
      {pollChoices.map((choice: PollChoice) => {
        const isSelected = choice.id === pollResponse.pcid;
        const isAnswer = choice.id === triviaAnswerId;
        const metric = metrics.find((m: Metric) => m.label === choice.label);

        return (
          <li
            key={choice.id}
            className={cx(
              'relative items-center px-4 py-2',
              isSelected
                ? isTrivia
                  ? isAnswer
                    ? 'text-gray-800'
                    : 'text-gray-800'
                  : 'text-gray-800'
                : 'text-gray-500',
            )}
          >
            <span>
              <span>{choice.label}</span>
              {hasLiveMetrics && metric && <span className="ml-2 text-xs opacity-75">({metric.percentage})</span>}
              <span className="absolute right-2 top-1/2 -translate-y-1/2 transform">
                {isTrivia && isAnswer && <CheckIcon className="h-4 w-4 text-green-500" />}
                {isSelected && isTrivia && !isAnswer && <XMarkIcon className="h-4 w-4 text-red-500" />}
                {isSelected && !isTrivia && <CheckIcon className="h-4 w-4 text-gray-500" />}
              </span>
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default ResultsStyleUnstyled;
